export default function(data, parentVM) {
  var self = this;

  self.parentVM = parentVM;
  self.loading = ko.observable(false);
  self.courseId = ko.observable();
  self.availableStudents = ko.observableArray([]);
  self.saved = ko.observable(false);
  self.removed = ko.observable(false);
  self.forum = ko.observable();
  self.parent = ko.observable();
  self.availableForums = ko.observableArray([]);

  self.bindData = function(data) {
    self.forum(ko.mapping.fromJS(data));
    self.forum().title.extend({required: {message: 'Title cannot be empty.'}});
    self.courseId(data.course_id);
    self.availableForums(ko.mapping.fromJS(data.forums)());
    self.forum().private.subscribe(function(newVal) {
      if (newVal)
        self.loadStudents();
    });
    self.parent(data.parent);
  };

  self.getAvailableForumData = ko.computed(function(){
    if(self.parent()){
      return self.parent();
    } else {
      return _.map(self.availableForums(), function(fVM){
        return fVM.forum();
      });
    }

  });

  self.reset = function() {
    self.saved(false);
    self.forum(forumTemplate);
  };

  self.initUI = function() {
  };

  self.remove = function() {
    Kadenze.UIUtil.confirmAction(
      'Deleting this forum will remove this forum and any subforums within it. Are you sure you wish to continue?',
      function() {
        var request = new Kadenze.AjaxRequest({
          type: 'DELETE',
          url: Kadenze.Routes.course_forum_path(self.courseId(), self.forum().id())
        });

        request.done(function() {
          new Kadenze.Notice.success({ message: 'Forum removed' });
          self.removed(true);
          $('#jsNewForumModal').modal('hide');
        });

        request.fail(function(data) {
          new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
          console.log('Forum Deletion FAILED');
          console.log(data.responseText);
        });
      }
    );
  };

  // Form validation
  self.validate = function() {
    self.clientErrors = ko.validation.group(self.forum, { deep: true });
    if (self.clientErrors().length === 0 || (self.clientErrors().length === 1 && self.clientErrors()[0] === null)) {
      return true;
    } else {
      self.clientErrors.showAllMessages();
      return false;
    }
  };

  self.save = function() {
    var requestType, urlPath;

    if(typeof self.forum === 'function' && typeof self.forum().id === 'function') {
      requestType = 'PATCH';
      urlPath = Kadenze.Routes.course_forum_path(self.courseId(), self.forum().id());
    } else {
      requestType = 'POST';
      urlPath = Kadenze.Routes.course_forums_path(self.courseId());
    }

    if (self.validate()) {
      var mapping = {
        'ignore': ['parentVM']
      };

      var request = new Kadenze.AjaxRequest({
        type: requestType,
        url: urlPath,
        data: {forum: ko.mapping.toJS(self.forum, mapping)},
        loadingIndicator: {
          container: $('#jsNewForumModal'),
          positionTop: 'fixed',
          message: 'Saving...'
        }
      });

      request.done(function(data, status, xhr) {
        new Kadenze.Notice.success({message: 'Successfully created forum'});

        if( data ) {
          var mapped_forum = ko.mapping.fromJSON(data.forum);
          // in memory refresh if new forum is subforum of recently created forum
          if(self.forum().parent_id() && self.forum().parent_id() == mapped_forum.parent_id() && self.parentVM.stateChanged()) {
            self.parentVM.forums().pop().forum().subforums.push(mapped_forum);
          } else {
            self.forum(mapped_forum);
            if(_.isEmpty(self.forum().subforums())) {
              self.parentVM.stateChanged(true);
            }
          }
        }
        self.saved(true);

        $('#jsNewForumModal').modal('hide');
      });

      request.fail(function(xhr, status, error) {
        console.log('request fail', error);

        var errors = xhr.responseJSON.errors;
        var message = '';

        if (errors.length && errors.length > 0) {
          message = ' ';

          _.each(errors, function(err, idx) {
            if (idx > 0)
              message += ', ';

            message += err;
          });
        }
        else {
          message = 'An unknown error prevented the thread from saving.';
        }

        new Kadenze.Notice.error({message: message});
      });
    }
  };

  self.loadStudents = function() {
    // issue ajax call to get eligible students
    self.loading(true);

    if (self.availableStudents().length == 0) {
      var request = new Kadenze.AjaxRequest({
        url: Kadenze.Routes.course_list_students_path(self.courseId()),
        type: 'GET',
        loadingIndicator: {
          container: $('#js-private-students'),
          message: 'Loading student list...',
          position: 'top'
        }
      });

      request.done(function(data, status, xhr) {
        self.availableStudents(ko.mapping.fromJS(data)());
      });

      request.fail(function(xhr, status, error) {
        Kadenze.Notice.error({message: 'There was a problem loading the student list. Please try again later or contact support.'});
      });

      request.always(function() {
        self.loading(false);
      });
    }
  };

  self.sortedStudents = function() {
    return _.sortBy(self.availableStudents(), function(student) { return student.first_name(); });
  };

  const __construct = function(that) {
    that.bindData(data);
    that.initUI();
  }(this);
}
